import { useState } from "react";

//TODO: Add options for resolving merge conflicts
export function useSyncedState<T>(syncedState: T): [T, (value: T) => void] {
    //The tracker approach keeps the component for re-rendering more than it needs to (only when setter is called)
    const [tracker] = useState({ updatedBySetter: false, previousSyncValue: syncedState, innerState: syncedState });
    //The trigger approach ensures that the component is refreshed even if the inner state is the same as the newState
    const [trigger, setTrigger] = useState(false);

    if (tracker.previousSyncValue !== syncedState) {
        tracker.innerState = syncedState;
        tracker.previousSyncValue = syncedState;
        tracker.updatedBySetter = false;
    }

    return [
        tracker.innerState,
        (newState: T) => {
            tracker.updatedBySetter = true;
            if (tracker.innerState !== newState) {
                tracker.innerState = newState
                setTrigger(!trigger);
            }
        }
    ]
}